import {
	applyBulkOperationsFilter,
	openBulkOperationsSection,
	openBulkConfigAuditSection,
	openBulkOperationTasksSection,
} from './adapter';

/**
 * Bulk Operations.
 *
 * Deliberately thin, the way Backup is: Bulk Addition, Bulk Deletion and
 * Bulk Actions are each a Sites/Access Points/Switches choice that already
 * belongs to those resources' own plugins (ap, switch, site), and this one
 * owns only the tab-level section a generic "bulk operations" lands on
 * before one of those is named, the `options` capability that offers them
 * as follow-ups, and the Bulk Operation Tasks history table underneath
 * them, which belongs to no device kind in particular.
 */
const bulkOperationsPlugin = {
	id: 'bulk_operations',
	version: 1,
	commandVersion: 1,
	resource: 'bulk_operations',
	operations: ['options', 'view_tasks', 'config_audit'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.bulk_operations': openBulkOperationsSection,
		'maintenance.bulk_operation_tasks': openBulkOperationTasksSection,
		'maintenance.bulk_config_audit': openBulkConfigAuditSection,
	},
	filters: {
		bulk_operations: applyBulkOperationsFilter,
	},
};

export default bulkOperationsPlugin;
